import { apiGet, apiPatch } from 'shared/services/api/resource';
import { MOCK_CLASS_GROUPS } from 'modules/arena/class-groups/content';
import { ClassGroup } from 'modules/arena/class-groups/types';

export function fetchClassGroups(): Promise<ClassGroup[]> {
  return apiGet(MOCK_CLASS_GROUPS, '/arena/class-groups');
}

export function toggleClassGroupStatus(groupId: string, status: ClassGroup['status']) {
  return apiPatch({ id: groupId, status }, `/arena/class-groups/${groupId}`, { status });
}

export function saveSessionAttendance(sessionId: string, presentStudentIds: string[]) {
  return apiPatch(
    { id: sessionId, presentStudentIds },
    `/arena/class-sessions/${sessionId}/attendance`,
    { presentStudentIds }
  );
}
